module.exports = __webpack_public_path__ + "img/Insurance.3151762e.svg";